import React from 'react';
import {render} from 'react-dom';
import './index.css';

const Tour = ({name}) => <nav>{name}</nav>;
class App extends React.Component {
	state = {
		finished: false
	}
	
	finishTour = () => this.setState({finished: true})
	repeatTour = () => this.setState({finished: false})
	render () {
		return (
			<div>
				<button onClick={this.finishTour}>Tour abgeschlossen</button>
				<button onClick={this.repeatTour}>Tour wiederholen</button>
				<div>
					Die Tour ist {
						this.state.finished 
						? "abgeschlossen" 
						: "wird wiederholt"
					}
				</div>
				<Tour name="Von Kamp Lintfort über Geldern nach Kevelaer" />
				<Tour name="Niederrhein: Entlang der Fossa Eugeniana" />
				<Tour name="Mit dem Rad rund um die Xantener Nordsee" />
			</div>
		)
	}
};

render (
	<App />,
	document.getElementById("root")
);


